import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import Tooltip from '../Tooltip';
import Button from '../Button';
import classNames from 'classnames';
import { isBoolean } from '@utiljs/is';
import { executeFoo } from '../_utils';
import { innerPlacement } from '../_utils/types';

var PopConfirm = /*#__PURE__*/function (_React$Component) {
  _inherits(PopConfirm, _React$Component);

  var _super = _createSuper(PopConfirm);

  function PopConfirm() {
    var _this;

    _classCallCheck(this, PopConfirm);

    _this = _super.apply(this, arguments);
    _this.state = {
      visible: (isBoolean(_this.props.defaultVisible) ? _this.props.defaultVisible : _this.props.visible) || false
    };

    _this.handleVisibleChange = function (s, cb) {
      _this.setState({
        visible: s
      }, cb);
    };

    _this.handleConfirm = function () {
      var onConfirm = _this.props.onConfirm;

      if (_this.isControlled) {
        executeFoo(onConfirm)();
      } else {
        _this.setState({
          visible: false
        }, function () {
          executeFoo(onConfirm)();
        });
      }
    };

    _this.handleCancel = function () {
      var onCancel = _this.props.onCancel;

      if (_this.isControlled) {
        executeFoo(onCancel)();
      } else {
        _this.setState({
          visible: false
        }, function () {
          executeFoo(onCancel)();
        });
      }
    };

    _this.handleTVisibleChange = function (s) {
      var onVisibleChange = _this.props.onVisibleChange;

      if (_this.isControlled) {
        executeFoo(onVisibleChange)(s);
      } else {
        _this.handleVisibleChange(s, function () {
          executeFoo(onVisibleChange)(s);
        });
      }
    };

    _this.renderContent = function () {
      var _this$props = _this.props,
          effect = _this$props.effect,
          content = _this$props.content,
          cancelBtnProps = _this$props.cancelBtnProps,
          confirmBtnProps = _this$props.confirmBtnProps;
      var type = effect === 'light' ? 'normal' : 'brand';
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, content), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '20px',
          textAlign: 'right'
        }
      }, /*#__PURE__*/React.createElement(Button, _Object$assign({
        size: "mini",
        type: "weaken",
        onClick: _this.handleCancel
      }, cancelBtnProps), "\u53D6\u6D88"), "\xA0\xA0", /*#__PURE__*/React.createElement(Button, _Object$assign({
        size: "mini",
        type: type,
        onClick: _this.handleConfirm
      }, confirmBtnProps), "\u786E\u8BA4")));
    };

    return _this;
  }

  _createClass(PopConfirm, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          effect = _this$props2.effect,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          placement = _this$props2.placement,
          trigger = _this$props2.trigger;

      if (disabled) {
        return children;
      }

      var clx = classNames('roo-popconfirm', className);
      return /*#__PURE__*/React.createElement(Tooltip, {
        effect: effect,
        popupClassName: clx,
        trigger: trigger,
        placement: placement,
        manual: true,
        content: this.renderContent(),
        visible: this.state.visible,
        onVisibleChange: this.handleTVisibleChange
      }, React.Children.only(children));
    }
  }, {
    key: "isControlled",
    get: function get() {
      return this.props.visible !== undefined;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, preState) {
      if (preState.visible !== nextProps.visible && nextProps.visible !== undefined) {
        return {
          visible: nextProps.visible
        };
      }

      return null;
    }
  }]);

  return PopConfirm;
}(React.Component);

PopConfirm.defaultProps = {
  visible: undefined,
  effect: 'light',
  trigger: 'click',
  className: undefined,
  disabled: false,
  cancelBtnProps: undefined,
  confirmBtnProps: undefined,
  placement: 'top',
  defaultVisible: false
};
PopConfirm.propTypes = {
  visible: PropTypes.bool,
  effect: PropTypes.oneOf(['light', 'dark']),
  trigger: PropTypes.oneOf(['hover', 'click']),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  cancelBtnProps: PropTypes.object,
  confirmBtnProps: PropTypes.object,
  placement: PropTypes.oneOf(innerPlacement),
  defaultVisible: PropTypes.bool
};
export default PopConfirm;